import { render, staticRenderFns } from "./AppointmentCompetention.vue?vue&type=template&id=0988fc44&scoped=true"
import script from "./AppointmentCompetention.vue?vue&type=script&lang=js"
export * from "./AppointmentCompetention.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCompetention.vue?vue&type=style&index=0&id=0988fc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988fc44",
  null
  
)

export default component.exports